import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Music, GlassWater, ConciergeBell, Check, ArrowRight, Mic, Headphones } from 'lucide-react';

const DJ_IMG = "https://customer-assets.emergentagent.com/job_7d11243e-bfc1-42ab-ab3b-8c95e25ccd72/artifacts/70vi058x_pexels-david-bares-42311-323687.jpg";
const MOCKTAIL_IMG = "https://customer-assets.emergentagent.com/job_7d11243e-bfc1-42ab-ab3b-8c95e25ccd72/artifacts/gjzszyyd_pexels-willians_photography-2157111846-34684084.jpg";
const SERVER_IMG = "https://customer-assets.emergentagent.com/job_7d11243e-bfc1-42ab-ab3b-8c95e25ccd72/artifacts/qk9eetk2_pexels-rdne-4921020.jpg";
const KARAOKE_IMG = "https://customer-assets-gfyr7b9c.emergentagent.net/job_mocktail-hub-6/artifacts/yjyqeazz_FA9B1528-C89D-4445-985E-95156B6DD1D5.png";
const BLINDTEST_IMG = "https://customer-assets-gfyr7b9c.emergentagent.net/job_mocktail-hub-6/artifacts/d9djihcf_2D11CB4D-D692-430A-9D17-266F10B5B6B3.png";

const prestations = [
  {
    id: "dj", icon: Music, title: "DJ & Animation", label: "Service #1", img: DJ_IMG,
    desc: "Ambiance musicale sur mesure pour vos soirées privées, anniversaires ou événements d'entreprise. DJ set et animation micro : je m'adapte à votre public et à votre thème avec du matériel son & lumière professionnel.",
    features: ["DJ Set personnalisé", "Animation micro", "Son & lumière pro", "Playlist sur mesure", "Tous styles musicaux"],
  },
  {
    id: "blindtest", icon: Headphones, title: "Blind Test Interactif", label: "Service #2", img: BLINDTEST_IMG,
    desc: "Transformez votre soirée en compétition musicale ! Les participants jouent depuis leur smartphone en temps réel : devinez les titres, gagnez des points et lancez des duels. Un écran TV affiche le classement en direct. Idéal pour les anniversaires, mariages et soirées d'entreprise.",
    features: ["Jouable depuis le smartphone", "Classement en temps réel sur écran TV", "Duels entre joueurs", "Mode Buzzer", "Quiz et QCM personnalisables", "Export PDF souvenir des scores"],
  },
  {
    id: "karaoke", icon: Mic, title: "Karaoké avec KaraFun", label: "Service #3", img: KARAOKE_IMG,
    desc: "Soirée karaoké professionnelle avec la plateforme KaraFun : plus de 60 000 titres disponibles en français et international. Micro sans fil, affichage des paroles sur grand écran, ambiance lumière et son de qualité. Chacun peut chanter ses titres préférés !",
    features: ["60 000+ titres KaraFun", "Micros sans fil professionnels", "Paroles sur grand écran", "File d'attente des chanteurs", "Son & lumière adaptés", "Tous styles : pop, rock, variété, rap..."],
  },
  {
    id: "bar", icon: GlassWater, title: "Bar à Mocktails", label: "Service #4", img: MOCKTAIL_IMG,
    desc: "Bar à cocktails sans alcool élégants et gourmands, créés sur mesure selon vos envies et votre thème. Possibilité d'atelier «Barman d'un jour» pour apprendre à shaker, doser et décorer vos propres mocktails avec vos invités.",
    features: ["Mocktails créatifs", "Recettes personnalisées", "Atelier Barman", "Bar mobile", "Présentation soignée"],
  },
  {
    id: "serveur", icon: ConciergeBell, title: "Serveur à Domicile", label: "Service #5", img: SERVER_IMG,
    desc: "Profitez de vos invités, on s'occupe du reste : mise en place de la table, service des plats et des boissons, débarrassage et rangement. Un service discret, souriant et professionnel pour transformer votre salon en véritable restaurant le temps d'une soirée.",
    features: ["Mise en place complète", "Service à table", "Débarrassage", "Rangement", "Discrétion assurée"],
  },
];

export default function Prestations() {
  return (
    <div className="fade-in" data-testid="prestations-page">
      <section className="py-12 md:py-20 px-4 md:px-8 max-w-6xl mx-auto text-center">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight mb-4" style={{ fontFamily: 'Outfit' }}>Nos Prestations</h1>
        <p className="text-base text-[#A1A1AA] max-w-xl mx-auto">{"Découvrez en détail nos cinq services pour faire de votre événement un moment inoubliable."}</p>
      </section>

      <section className="pb-16 px-4 md:px-8 max-w-6xl mx-auto space-y-20">
        {prestations.map((p, i) => (
          <div key={p.id} id={p.id} className="grid md:grid-cols-2 gap-8 items-center" data-testid={`prestation-${p.id}`}>
            <div className={i % 2 === 1 ? 'md:order-2' : ''}>
              <div className="relative rounded-2xl overflow-hidden h-72 md:h-96">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/50 to-transparent" />
                <div className="absolute bottom-4 left-4 bg-[#D4AF37]/15 backdrop-blur-md p-3 rounded-xl"><p.icon className="w-6 h-6 text-[#D4AF37]" /></div>
              </div>
            </div>
            <div className={i % 2 === 1 ? 'md:order-1' : ''}>
              <p className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-2">{p.label}</p>
              <h2 className="text-2xl md:text-3xl font-semibold mb-4" style={{ fontFamily: 'Outfit' }}>{p.title}</h2>
              <p className="text-[#A1A1AA] leading-relaxed mb-6">{p.desc}</p>
              <div className="space-y-3 mb-8">
                {p.features.map(f => (
                  <div key={f} className="flex items-center gap-3 text-sm"><Check className="w-4 h-4 text-[#D4AF37] shrink-0" /><span>{f}</span></div>
                ))}
              </div>
              <Link to="/reservation" data-testid={`reserve-${p.id}`}>
                <Button className="bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full px-6 text-sm font-semibold">Demander un devis <ArrowRight className="w-4 h-4 ml-2" /></Button>
              </Link>
            </div>
          </div>
        ))}
      </section>

      <section className="py-16 px-4 md:px-8" data-testid="pack-complet">
        <div className="max-w-3xl mx-auto gold-bg gold-border rounded-2xl p-8 md:p-12 text-center">
          <h2 className="text-2xl font-semibold mb-3" style={{ fontFamily: 'Outfit' }}>{"Prêt à organiser votre événement ?"}</h2>
          <p className="text-[#A1A1AA] mb-6 max-w-lg mx-auto">{"Contactez-nous dès aujourd'hui pour discuter de votre projet et recevoir un devis personnalisé."}</p>
          <Link to="/reservation" data-testid="reserve-complet"><Button className="bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full px-8 py-3 font-semibold">Demander un devis gratuit</Button></Link>
        </div>
      </section>
    </div>
  );
}
